
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlV as ObiOwnShipControlVElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-v.js';
 
 
 

 
 export const ObiOwnShipControlV = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-v',
   elementClass: ObiOwnShipControlVElement,
   events: {
     
   }
  });
 
 